import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const homeworks = [
    {
      id: 1,
      title: 'Homework 1',
      subtitle: 'Block-Based Image Averaging',
      description: 'Apply block averaging to images with configurable block dimensions',
      status: 'completed',
      route: '/homework/1'
    },
    {
      id: 2,
      title: 'Homework 2',
      subtitle: 'Image Transformations & Color Spaces',
      description: 'Apply geometric transformations and color space conversions to images',
      status: 'completed',
      route: '/homework/2'
    },
    {
      id: 3,
      title: 'Homework 3',
      subtitle: 'Histogram Operations',
      description: 'Histogram stretching, equalization, and custom transfer functions',
      status: 'completed',
      route: '/homework/3'
    },
    {
      id: 4,
      title: 'Homework 4',
      subtitle: 'Spatial Filtering & Enhancement',
      description: 'Noise reduction filters and multi-step bone scan enhancement',
      status: 'completed',
      route: '/homework/4'
    },
    {
      id: 5,
      title: 'Homework 5',
      subtitle: 'Frequency Domain Filtering',
      description: 'Butterworth highpass, notch reject, and band reject filters for edge enhancement and periodic noise removal',
      status: 'completed',
      route: '/homework/5'
    },
    {
      id: 6,
      title: 'Homework 6',
      subtitle: 'Image Restoration & Noise Removal',
      description: 'Add various types of noise and remove them using spatial and frequency domain filters',
      status: 'completed',
      route: '/homework/6'
    },
    {
      id: 7,
      title: 'Homework 7',
      subtitle: 'Advanced Image Restoration',
      description: 'Multi-step restoration: Median, Wiener, Motion Deblur & FFT Notch filtering',
      status: 'completed',
      route: '/homework/7'
    },
    {
      id: 8,
      title: 'Homework 8',
      subtitle: 'Morphological Image Processing',
      description: 'Noise removal, gradient extraction, rice segmentation, and blob separation using morphology',
      status: 'completed',
      route: '/homework/8'
    },
    {
      id: 9,
      title: 'Homework 9',
      subtitle: 'Image Segmentation',
      description: 'OTSU automatic thresholding and region growing for image segmentation',
      status: 'completed',
      route: '/homework/9'
    }
  ];

  return (
    <div className="homepage">
      <div className="hero-section animate-fade-in-up">
        <h1>EEE410 - Introduction to Image Processing</h1>
        <h2>Fall 2025 - Homework Hub</h2>
        <p className="student-info">Emir Ersel Bilgiç - 200403063</p>
        <p>Interactive web applications for image processing assignments</p>
      </div>

      <div className="homeworks-grid">
        {homeworks.map((hw, index) => (
          <div
            key={hw.id}
            className={`homework-card ${hw.status} animate-fade-in-up`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="card-content">
              <div className="card-header">
                <h3>{hw.title}</h3>
                <span className={`status-indicator ${hw.status}`}>
                  {hw.status === 'completed' ? '●' : '○'}
                </span>
              </div>

              <h4>{hw.subtitle}</h4>
              <p className="description">{hw.description}</p>
            </div>

            <div className="card-action">
              {hw.status === 'completed' ? (
                <Link to={hw.route} className="hw-button available">
                  Open Assignment
                  <span className="arrow">→</span>
                </Link>
              ) : (
                <button className="hw-button disabled" disabled>
                  Coming Soon
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="footer-info">
        <div className="course-info">
          <h3>Course Information</h3>
          <p><strong>Course:</strong> EEE410 - Introduction to Image Processing</p>
          <p><strong>Semester:</strong> Fall 2025</p>
          <p><strong>Platform:</strong> Interactive Web Applications</p>
        </div>

        <div className="tech-stack">
          <h3>Technology Stack</h3>
          <div className="tech-badges">
            <span className="tech-badge">React</span>
            <span className="tech-badge">TypeScript</span>
            <span className="tech-badge">Firebase Functions</span>
            <span className="tech-badge">Python</span>
            <span className="tech-badge">NumPy</span>
            <span className="tech-badge">Pillow</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;